import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const uploadModelStatusManager = {
  uploadModelStatus(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default uploadModelStatusManager;
